module.exports = __webpack_public_path__ + "img/individual-meter-heat-meter-counter-md.d449c072.svg";